export default {
    methods: {
        getEnv(key) {
            return process.env[key] || null
        }
    }
}
